import apiClient from '../utils/apiClient';

const COUNTRY_CODES = {
  england: 'EN',
  austria: 'AT',
  belgium: 'BE',
  switzerland: 'CH',
  'czech republic': 'CZ',
  germany: 'DE',
  spain: 'ES',
  france: 'FR',
  ireland: 'IE',
  italy: 'IT',
  netherlands: 'NL',
  norway: 'NO',
  poland: 'PL',
  portugal: 'PT',
  romania: 'RO',
  sweden: 'SE',
  slovakia: 'SK',
  turkey: 'TR',
};

const toCountryCode = (country) => {
  const normalizedCountry = String(country || '').trim();
  if (/^[a-z]{2}$/i.test(normalizedCountry)) {
    return normalizedCountry.toUpperCase();
  }

  return COUNTRY_CODES[normalizedCountry.toLowerCase()] || normalizedCountry;
};

export const fetchTranslationFiles = () =>
  apiClient.get('/translator/files', {
    headers: {
      'Cache-Control': 'no-cache',
    },
  });

export const uploadTranslationFileToPre = ({ file, country, language, type }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('country', toCountryCode(country));
  formData.append('language', language);
  formData.append('type', type);

  return apiClient.post('/translator/files/pre/upload', formData);
};

export const publishTranslationFileToPre = (fileId) =>
  apiClient.post('/translator/files/pre/publish', { fileId });

export const publishTranslationFileToPro = (fileId, password) =>
  apiClient.post('/translator/files/pro/publish', { fileId, password });

export const deletePendingTranslationFile = (fileId) =>
  apiClient.delete(`/translator/files/${fileId}`);

export const downloadTranslationFileFromPre = (filename) =>
  apiClient.get('/translator/files/pre/download', {
    params: { filename },
    responseType: 'blob',
  });

export const fetchPreviewToken = (role, language, country) =>
  apiClient.get('/translator/preview-token', { params: { role, language, country } });